<ion-card class="email-pop-up-card">
  <ion-card-header>
    <ion-card-title>
      {{texts.personal.mail.popUpTitle | translate }} {{ titleName$ | async }}
    </ion-card-title>
  </ion-card-header>

  <ion-card-content>
    <mat-form-field class="admia-form-item">
    <textarea
      [formControl]="email"
      [placeholder]="texts.personal.mail.title | translate"
      matInput
      rows="{{ rows }}"
    ></textarea>
    </mat-form-field>

    <ion-button (click)="deleteEmail()">
      {{texts.personal.mail.okDeleteMail | translate }}
    </ion-button>

    <ion-button (click)="close()">
      {{texts.personal.mail.dontDeleteMail | translate }}
    </ion-button>

  </ion-card-content>
</ion-card>
